
export enum EventTypes {
  UserData,
  Shopping,
  Message,
  Modal,
  RightSideBar,
  TaxonomyTree,

}
